"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.marginClasses = exports.m = exports.my = exports.mx = exports.ml = exports.mb = exports.mr = exports.mt = void 0;
var util_1 = require("./util");
var Margin_module_scss_1 = __importDefault(require("./Margin.module.scss"));
var mt = function (unit) { return [
    Margin_module_scss_1["default"]["mt-".concat((0, util_1.convertFractionToString)(unit))],
]; };
exports.mt = mt;
var mr = function (unit) { return [
    Margin_module_scss_1["default"]["mr-".concat((0, util_1.convertFractionToString)(unit))],
]; };
exports.mr = mr;
var mb = function (unit) { return [
    Margin_module_scss_1["default"]["mb-".concat((0, util_1.convertFractionToString)(unit))],
]; };
exports.mb = mb;
var ml = function (unit) { return [
    Margin_module_scss_1["default"]["ml-".concat((0, util_1.convertFractionToString)(unit))],
]; };
exports.ml = ml;
var mx = function (unit) { return [
    Margin_module_scss_1["default"]["ml-".concat((0, util_1.convertFractionToString)(unit))],
    Margin_module_scss_1["default"]["mr-".concat((0, util_1.convertFractionToString)(unit))],
]; };
exports.mx = mx;
var my = function (unit) { return [
    Margin_module_scss_1["default"]["mt-".concat((0, util_1.convertFractionToString)(unit))],
    Margin_module_scss_1["default"]["mb-".concat((0, util_1.convertFractionToString)(unit))],
]; };
exports.my = my;
var m = function (unit) {
    var classes = [];
    if (typeof unit === "number") {
        classes.push(Margin_module_scss_1["default"]["m-".concat((0, util_1.convertFractionToString)(unit))]);
    }
    else {
        Object.keys(unit).forEach(function (key) {
            classes.push(Margin_module_scss_1["default"]["m-".concat((0, util_1.convertFractionToString)(unit[key]), "--").concat(key)]);
        });
    }
    return classes;
};
exports.m = m;
var marginClasses = function (_a) {
    var margin = _a.m, marginTop = _a.mt, marginRight = _a.mr, marginBottom = _a.mb, marginLeft = _a.ml, marginXAxis = _a.mx, marginYAxis = _a.my, _b = _a.rtl, rtl = _b === void 0 ? false : _b;
    var classes = [];
    if (margin !== undefined)
        classes.push.apply(classes, (0, exports.m)(margin));
    if (marginTop !== undefined)
        classes.push.apply(classes, (0, exports.mt)(marginTop));
    if (marginBottom !== undefined)
        classes.push.apply(classes, (0, exports.mb)(marginBottom));
    if (marginXAxis !== undefined)
        classes.push.apply(classes, (0, exports.mx)(marginXAxis));
    if (marginYAxis !== undefined)
        classes.push.apply(classes, (0, exports.my)(marginYAxis));
    if (rtl) {
        // for RTL languages, swap the left and right margin
        if (marginRight !== undefined)
            classes.push.apply(classes, (0, exports.ml)(marginRight));
        if (marginLeft !== undefined)
            classes.push.apply(classes, (0, exports.mr)(marginLeft));
    }
    else {
        if (marginRight !== undefined)
            classes.push.apply(classes, (0, exports.mr)(marginRight));
        if (marginLeft !== undefined)
            classes.push.apply(classes, (0, exports.ml)(marginLeft));
    }
    // if no padding defined on any param, default to 0
    if (margin === undefined &&
        marginTop === undefined &&
        marginRight === undefined &&
        marginBottom === undefined &&
        marginLeft === undefined &&
        marginXAxis === undefined &&
        marginYAxis === undefined) {
        classes.push.apply(classes, (0, exports.m)(0));
    }
    return classes;
};
exports.marginClasses = marginClasses;
//# sourceMappingURL=margin.js.map